export const EnquiryTypes = {
	CREATE_FRANCHISE_ENQUIRY: "CREATE_FRANCHISE_ENQUIRY",
	CREATE_FRANCHISE_ENQUIRY_SUCCESS: "CREATE_FRANCHISE_ENQUIRY_SUCCESS",

	GET_FRANCHISE_DETAILS: "GET_FRANCHISE_DETAILS",
	GET_FRANCHISE_DETAILS_SUCCESS: "GET_FRANCHISE_DETAILS_SUCCESS",

	CREATE_CONTACT_US: "CREATE_CONTACT_US",
	CREATE_CONTACT_US_SUCCESS: "CREATE_CONTACT_US_SUCCESS",

	GET_CONTACT_US_DETAILS: "GET_CONTACT_US_DETAILS",
	GET_CONTACT_US_DETAILS_SUCCESS: "GET_CONTACT_US_DETAILS_SUCCESS",

	CREATE_FEEDBACK: "CREATE_FEEDBACK",
	CREATE_FEEDBACK_SUCCESS: "CREATE_FEEDBACK_SUCCESS",

	GET_FEEDBACKS: "GET_FEEDBACKS",
	GET_FEEDBACKS_SUCCESS: "GET_FEEDBACKS_SUCCESS",

	ENQUIRE_ERROR: "ENQUIRE_ERROR",
};
